import { render } from "./CardForm.component.vue?vue&type=template&id=4a4b2dc8"
import script from "./CardForm.component.vue?vue&type=script&lang=js"
export * from "./CardForm.component.vue?vue&type=script&lang=js"

import "./CardForm.component.vue?vue&type=style&index=0&id=4a4b2dc8&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QField from 'quasar/src/components/field/QField.js';
import qInstall from "../../../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QField});
